// Custom template for project
export const projectInitialTemplate = {
  subject: 'Notification email template',
  subTitle: 'Confirm your email address',
  content: {
    type: 'page',
    data: {
      value: {
        breakpoint: '480px',
        headAttributes: '',
        'font-size': '19px',
        'font-weight': '450',
        'line-height': '1.7',
        headStyles: [],
        fonts: [],
        responsive: true,
        'font-family':
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans','Helvetica Neue', sans-serif",
        'text-color': '#000000',
      },
    },
    attributes: {
      'background-color': '#F3F1F1',
      width: '1000px',
    },
    children: [
      {
        type: 'wrapper',
        data: {
          value: {},
        },
        attributes: {
          padding: '60px 0px 60px 0px',
          border: 'none',
          direction: 'ltr',
          'text-align': 'center',
        },
        children: [
          {
            type: 'advanced_image',
            data: {
              value: {},
            },
            attributes: {
              align: 'center',
              height: '41px',
              padding: '0px 0px 0px 0px',
              src: 'https://fem-fast-dev-images.s3.eu-central-1.amazonaws.com/assets/67f38242666f75b889c89aee-media1744190981556.png',
              width: '284px',
              href: 'https://maion-ai-web-app-dev.vercel.app/',
            },
            children: [],
          },
        ],
      },
      {
        type: 'section',
        data: {
          value: {
            noWrap: false,
          },
        },
        attributes: {
          padding: '20px 0px 40px 0px',
          'background-repeat': 'repeat',
          'background-size': 'auto',
          'background-position': 'top center',
          border: 'none',
          direction: 'ltr',
          'text-align': 'center',
          'background-color': '#FFFFFF',
        },
        children: [
          {
            type: 'advanced_column',
            data: {
              value: {},
            },
            attributes: {
              padding: '0px 20px 0px 20px',
              border: 'none',
              'vertical-align': 'top',
              width: '600',
            },
            children: [
              {
                type: 'advanced_image',
                data: {
                  value: {},
                },
                attributes: {
                  align: 'center',
                  height: '50px',
                  padding: '0px 0px 0px 0px',
                  src: 'https://fem-fast-dev-images.s3.eu-central-1.amazonaws.com/assets/67f38242666f75b889c89aee-media1744194552077.png',
                  width: '50px',
                },
                children: [],
              },
              {
                type: 'advanced_text',
                data: {
                  value: {
                    content: '<span>Accept your invitation</span><br>',
                  },
                },
                attributes: {
                  padding: '10px 25px 10px 25px',
                  align: 'center',
                  'font-family': 'Tahoma',
                  'font-size': '34px',
                  'font-weight': '500',
                  color: '#f58d77',
                  'text-decoration': '',
                },
                children: [],
              },
              {
                type: 'advanced_text',
                data: {
                  value: {
                    content:
                      'You’ve been invited to join FemFast. To get started, please click the link below to accept your invitation and set up your account.',
                  },
                },
                attributes: {
                  padding: '10px 0px 10px 0px',
                  align: 'left',
                  'font-size': '19px',
                  'font-family': 'Arial',
                },
                children: [],
              },
              {
                type: 'advanced_text',
                data: {
                  value: {
                    content:
                      '<a href="{{link}}" target="_blank" style="color: inherit; text-decoration: none;" tabindex="-1"><font color="#4185f4" style=""><b style="">Accept Invitation</b></font></a>',
                  },
                },
                attributes: {
                  padding: '10px 0px 10px 0px',
                  align: 'center',
                  'font-size': '19px',
                  'font-family': 'Arial',
                  'font-weight': '600',
                  'text-decoration': 'none',
                },
                children: [],
              },
              {
                type: 'advanced_text',
                data: {
                  value: {
                    content: '<b>– The FemFast Team</b>',
                  },
                },
                attributes: {
                  padding: '10px 0px 10px 0px',
                  align: 'left',
                  'font-family': 'Arial',
                  'font-weight': '500',
                  'line-height': '',
                  'font-size': '19px',
                  'letter-spacing': '5',
                },
                children: [],
              },
              {
                type: 'advanced_text',
                data: {
                  value: {
                    content:
                      '<i><font size="3">If you did not expect this invitation, you can safely ignore this email.</font></i>',
                  },
                },
                attributes: {
                  padding: '10px 0px 10px 0px',
                  align: 'left',
                  'font-weight': '400',
                  'font-family': 'Arial',
                  'font-size': '16px',
                  'line-height': '2',
                  'letter-spacing': '5',
                },
                children: [],
              },
            ],
          },
        ],
      },
      {
        type: 'advanced_text',
        data: {
          value: {
            content: 'FemFast Inc. 2025 © All rights reserved.',
          },
        },
        attributes: {
          padding: '4px 0px 20px 0px',
          align: 'right',
          'font-size': '12px',
          'font-family': 'Arial',
          'font-weight': '500',
          color: '#646363',
        },
        children: [],
      },
    ],
  },
}
